import { render, staticRenderFns } from "./CsuFamilyHistoryPhase.vue?vue&type=template&id=1248f81f&scoped=true&"
import script from "./CsuFamilyHistoryPhase.vue?vue&type=script&lang=js&"
export * from "./CsuFamilyHistoryPhase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1248f81f",
  null
  
)

export default component.exports